import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod/v4'

export const env = createEnv({
  server: {
    /** Is CI */
    CI: z.string().optional(),
    /** CI Branch */
    CI_BRANCH: z.string().optional(),
    /** CI Unique string for build */
    CI_BUILD_INFO: z.string().optional(),
    /** CI Build number */
    CI_BUILD_NUMBER: z.coerce.number().int().positive().optional(),
    /** CI Build time */
    CI_BUILD_TIME: z.string().optional(),
    /** CI Git SHA */
    CI_GIT_SHA: z.string().optional(),
    /** CI Git SHA Short */
    CI_GIT_SHA_SHORT: z.string().optional(),
    /** Override Postgres credentials */
    DB_URL: z.string().optional(),
    /** Pre-configured Postgres credential */
    DB_URL_DEMO: z.string().optional(),
    /** Pre-configured Postgres credential */
    DB_URL_STAGING: z.string().optional(),
    /** Pre-configured Postgres credential */
    DB_URL_PROD: z.string().optional(),
    /** RSC Header Title */
    DISPLAY_ENV: z.string().nonempty(),
    /** Used by the bundler and some logging distinctions */
    NODE_ENV: z.enum(['development', 'production', 'test']).default('development'),
    /** jose jwt secret */
    SESSION_SECRET: z.string().nonempty(),
    /** Used by SST for deployment */
    SST_STAGE: z.string().optional(),
    /** API base URL override */
    STOGO_HOST: z.string().optional(),
  },
  client: {
    /** React client Is CI */
    NEXT_PUBLIC_CI: z.string().optional(),
    /** React client CI Branch */
    NEXT_PUBLIC_CI_BRANCH: z.string().optional(),
    /** React client CI Unique string for build */
    NEXT_PUBLIC_CI_BUILD_INFO: z.string().optional(),
    /** React client CI Build number */
    NEXT_PUBLIC_CI_BUILD_NUMBER: z.coerce.number().int().positive().optional(),
    /** React client CI Build time */
    NEXT_PUBLIC_CI_BUILD_TIME: z.string().optional(),
    /** React client CI Git SHA */
    NEXT_PUBLIC_CI_GIT_SHA: z.string().optional(),
    /** React client CI Git SHA Short */
    NEXT_PUBLIC_CI_GIT_SHA_SHORT: z.string().optional(),
    /** API base URL override */
    NEXT_PUBLIC_API_URL: z.string().optional(),
    /** React client Header Title */
    NEXT_PUBLIC_DISPLAY_ENV: z.string().nonempty(),
    /** React client logging distinctions */
    NEXT_PUBLIC_NODE_ENV: z.enum(['development', 'production', 'test']).default('development'),
    /** Not implemented */
    NEXT_PUBLIC_SST_STAGE: z.string().optional(),
  },
  // If you're using Next.js < 13.4.4, you'll need to specify the runtimeEnv manually
  runtimeEnv: {
    CI_BRANCH: process.env.CI_BRANCH,
    CI_BUILD_INFO: process.env.BUILD_INFO,
    CI_BUILD_NUMBER: process.env.CI_BUILD_NUMBER,
    CI_BUILD_TIME: process.env.CI_BUILD_TIME,
    CI_GIT_SHA: process.env.CI_GIT_SHA,
    CI_GIT_SHA_SHORT: process.env.CI_GIT_SHA_SHORT,
    CI: process.env.CI,
    DB_URL: process.env.DB_URL,
    DB_URL_DEMO: process.env.DB_URL_DEMO,
    DB_URL_STAGING: process.env.DB_URL_STAGING,
    DB_URL_PROD: process.env.DB_URL_PROD,
    DISPLAY_ENV: process.env.DISPLAY_ENV,
    NODE_ENV: process.env.NODE_ENV,
    SESSION_SECRET: process.env.SESSION_SECRET,
    SST_STAGE: process.env.SST_STAGE,
    NEXT_PUBLIC_CI: process.env.NEXT_PUBLIC_CI,
    NEXT_PUBLIC_CI_BRANCH: process.env.NEXT_PUBLIC_CI_BRANCH,
    NEXT_PUBLIC_CI_BUILD_INFO: process.env.NEXT_PUBLIC_CI_BUILD_INFO,
    NEXT_PUBLIC_CI_BUILD_NUMBER: process.env.NEXT_PUBLIC_CI_BUILD_NUMBER,
    NEXT_PUBLIC_CI_BUILD_TIME: process.env.NEXT_PUBLIC_CI_BUILD_TIME,
    NEXT_PUBLIC_CI_GIT_SHA: process.env.NEXT_PUBLIC_CI_GIT_SHA,
    NEXT_PUBLIC_CI_GIT_SHA_SHORT: process.env.NEXT_PUBLIC_CI_GIT_SHA_SHORT,
    NEXT_PUBLIC_DISPLAY_ENV: process.env.NEXT_PUBLIC_DISPLAY_ENV,
    NEXT_PUBLIC_NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_SST_STAGE: process.env.NEXT_PUBLIC_SST_STAGE,
    NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
    STOGO_HOST: process.env.STOGO_HOST,
  },
  // For Next.js >= 13.4.4, you only need to destructure client variables:
  // experimental__runtimeEnv: {
  // },
})
